var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.145 3.85l4.33 2.5a.75.75 0 01.274 1.025L10.5 18.2a.744.744 0 01-.031.05H17.5a.75.75 0 010 1.5h-11a.75.75 0 01-.75-.709.751.751 0 01-.038-.11l-.458-1.705v-.002l-.459-1.704a.75.75 0 01.075-.57l6.25-10.825a.75.75 0 011.025-.274zm2.93 3.425L13.95 9.223l-3.03-1.75 1.124-1.948 3.031 1.75zM13.2 10.522l-3.03-1.75-3.845 6.66.297 1.105 1.627.94 1.107-.296 3.844-6.659z",
    fill: "currentColor"
  })));
}

export default SvgEdit;